import { IPropostaConfirmacaoValoresCreditoImobiliario } from '@/interfaces'
import { PROPOSTA_CONFIRMACAO_VALORES_ACAO } from '@/types'

export class PropostaConfirmacaoValoresCreditoImobiliario implements IPropostaConfirmacaoValoresCreditoImobiliario {
	PropostaId: number
	PropostaBancoId: number
	UserId: number
	ValorCompraVenda: number
	ValorEntrada: number
	ValorEntradaFGTS: number
	ValorFinanciamento: number
	ValorAvaliacaoBanco: number
	ValorTarifaAvaliacaBanco: number
	ValorTaxaAcordada: number
	ValorITBI: number
	ValorIQ: number
	ValorPagamentoVendedores: number
	Prazo: number
	Canal: number
	Acao: PROPOSTA_CONFIRMACAO_VALORES_ACAO
	PossuiIQ: boolean
	DataIQ: string | null
	TipoOperacaoProduto: number | null

	constructor(jsonData: string) {
		const data = JSON.parse(jsonData)

		this.PropostaId = parseInt(data.PropostaId)
		this.PropostaBancoId = parseInt(data.PropostaBancoId)
		this.UserId = parseInt(data.UserId)
		this.ValorCompraVenda = parseFloat(data.ValorCompraVenda)
		this.ValorEntrada = parseFloat(data.ValorEntrada)
		this.ValorEntradaFGTS = parseFloat(data.ValorEntradaFGTS)
		this.ValorFinanciamento = parseFloat(data.ValorFinanciamento)
		this.ValorAvaliacaoBanco = parseFloat(data.ValorAvaliacaoBanco)
		this.ValorTarifaAvaliacaBanco = parseFloat(data.ValorTarifaAvaliacaBanco)
		this.ValorTaxaAcordada = parseFloat(data.ValorTaxaAcordada)
		this.ValorITBI = parseFloat(data.ValorITBI)
		this.ValorIQ = parseFloat(data.ValorIQ)
		this.ValorPagamentoVendedores = parseFloat(data.ValorPagamentoVendedores)
		this.Prazo = parseInt(data.Prazo)
		this.Canal = data.Canal
		this.Acao = data.Acao
		this.PossuiIQ = data.PossuiIQ
		this.DataIQ = data.DataIQ
		this.TipoOperacaoProduto = parseInt(data.TipoOperacaoProduto) || -1
		
	}
}
